export function PC_HORIZONTAL_SPACE_BETWEEN_ITEMS(multiplier: number =  1) {
    return (15 * multiplier) + 'px';
}

export function MOBILE_HORIZONTAL_SPACE_BETWEEN_ITEMS(multiplier: number =  1) {
    return (5 * multiplier) + 'px';
}